import { navigationDrawerStyles } from "@insite/content-library/Components/NavigationDrawer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

navigationDrawerStyles.menuTriggerButton = {
    size: 48,
    css: css`
        border: none;
        background: transparent;
        &:hover, :focus {
            background: transparent !important;
            border-color: transparent !important;
            outline: none;
        }
        & span {
            color: ${getColor("primary.main")} !important;
        }
    `
};
